<script lang="ts">
  import CmsImage from '$components/cms-image.svelte';
  import { storyblokEditable } from '$lib/actions/storyblok-editable';
  import { getAnchorFromCmsLink } from '$lib/utils/cms';
  import { createBreakpointMediaQueryStore } from '$lib/stores/media';
  import type { CollectionCardStoryblok } from '$types/bloks';

  export let block: CollectionCardStoryblok;
  const desktop = createBreakpointMediaQueryStore('lg');
</script>

{#if block}
  {@const link = block.link ? $getAnchorFromCmsLink(block.link) : null}
  <section class="relative px-2 py-1 lg:px-8 lg:py-2" use:storyblokEditable={block}>
    <a
      href={link?.href}
      rel={link?.rel}
      target={link?.target}
      class="container bg-primary hover:after:bg-primary/4 isolate mx-auto flex flex-col text-center gap-2 outline-none border-none shadow-none focus-visible:ring rounded-md motion-safe:transition-shadow after:motion-safe:transition-colors after:absolute after:inset-0 relative overflow-hidden"
    >
      <CmsImage
        image={!$desktop && block?.mobile_image ? block?.mobile_image : block.image}
        class="aspect-square min-h-[400px] w-full overflow-hidden rounded-md object-cover object-center lg:aspect-auto lg:h-[480px] pointer-events-none"
        options={{ size: [1920, 0] }}
      />
      <p
        class="text-6xl z-10 pointer-events-none font-semibold text-highlight w-full p-8 absolute left-0 top-[50%] -translate-y-[50%]"
      >
        {block.title}
      </p>
    </a>
  </section>
{/if}
